export default "__VITE_ASSET__CdVTWPNS__"